import { BindingEngine } from "aurelia-binding";
import { DialogController } from 'aurelia-dialog';
import { autoinject, observable, computedFrom } from 'aurelia-framework';
import { applicationLogger } from '../logging/logger';
import { Location } from "../models/location";

import { IState, LocationState } from "../store/state";
import { updateLocationState } from "../store/actions/location-actions";
import { Store } from "aurelia-store";


@autoinject
export class LocationManagementDialog {
	dialogController: DialogController;
	
	selectLabel: string;
	locationState: LocationState;
	@observable selectAll: boolean;
	private subscription: any;

	constructor(private store: Store<IState>, dialogController: DialogController, bindingEngine: BindingEngine) {
		this.dialogController = dialogController;
		this.selectLabel = "Select All";

	}

	bind() {
		this.subscription = this.store.state.subscribe((state) => {
			
			this.locationState = Object.assign({}, state.locationState);
			this.selectAll = this.locationState.locations.length === this.locationState.selectedLocations.length;
			});
	}
	unbind() {
		this.subscription.unsubscribe();
	}

	activate() {
		
		applicationLogger.debug("LocationManagementDialog activated.");
	}

	selectedLocationsChanged() {
		this.selectAll = this.locationState.locations.length === this.locationState.selectedLocations.length;
	}

	selectAllChanged(newValue, oldValue) {
		if (oldValue === undefined) {
			return;
		}

		if (newValue === false) {
			this.locationState.selectedLocations = new Array<Location>();
		} else {
			this.locationState.selectedLocations = new Array<Location>();
			for (let i = 0; i < this.locationState.locations.length; i++) {
				this.locationState.selectedLocations[i] = this.locationState.locations[i];
			}
		}
		
	}
	
	async acceptChanges() {
		await this.store.dispatch(updateLocationState, this.locationState);
		this.dialogController.ok();
	}
}